"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRefreshLink = exports.OperationQueuing = void 0;
var core_1 = require("@apollo/client/core");
var queuing_1 = require("./queuing");
var queuing_2 = require("./queuing");
Object.defineProperty(exports, "OperationQueuing", { enumerable: true, get: function () { return queuing_2.OperationQueuing; } });
var AuthConsumer_1 = require("./AuthConsumer");
var TokenRefreshLink = /** @class */ (function (_super) {
    __extends(TokenRefreshLink, _super);
    function TokenRefreshLink(consumer, onError, debug) {
        if (debug === void 0) { debug = false; }
        var _this = _super.call(this) || this;
        _this.consumer = consumer;
        _this.handleError = typeof onError === 'function'
            ? onError
            : function (err) {
                console.error(err);
            };
        _this.fetching = false;
        _this.queue = new queuing_1.OperationQueuing();
        _this.debug = debug;
        return _this;
    }
    TokenRefreshLink.prototype.request = function (operation, forward) {
        var _this = this;
        if (typeof forward !== 'function') {
            throw new Error('[Token Refresh Link]: Token Refresh Link is a non-terminating link and should not be the last in the composed chain');
        }
        if (!this.shouldRefresh()) {
            return forward(operation);
        }
        if (!this.fetching) {
            this.fetching = true;
            this.refreshTokens()
                .catch(this.handleError)
                .finally(function () {
                _this.fetching = false;
                _this.queue.consumeQueue();
            });
        }
        return this.queue.enqueueRequest({
            operation: operation,
            forward: forward,
        });
    };
    TokenRefreshLink.prototype.shouldRefresh = function () {
        return this.consumer.isExpired() || this.consumer.isExpiring();
    };
    TokenRefreshLink.prototype.refreshTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentTokens, response, at, ps, _a, accessToken, refreshToken;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.debug) {
                            console.log(new Date(), 'attempt to refresh tokens');
                        }
                        return [4 /*yield*/, this.consumer.getTokens()];
                    case 1:
                        currentTokens = _b.sent();
                        return [4 /*yield*/, this.consumer.getRefreshTokens(currentTokens)
                            // account for race conditions
                        ];
                    case 2:
                        response = _b.sent();
                        if (!(response.status === 205)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.consumer.getAccessToken()
                            // if access hasn't updated in store, watch for changes before resolving
                        ];
                    case 3:
                        at = _b.sent();
                        // if access hasn't updated in store, watch for changes before resolving
                        if (at === (currentTokens === null || currentTokens === void 0 ? void 0 : currentTokens.accessToken)) {
                            if (this.debug) {
                                console.log(new Date(), 'wait for pending store change for new token');
                            }
                            ps = new Promise(function (resolve) {
                                _this.consumer.subscribeToKey(AuthConsumer_1.TOKEN_KEY, function (nextToken) {
                                    if (_this.debug) {
                                        console.log(new Date(), 'new token stored, finish refresh', nextToken);
                                    }
                                    // if nextToken is null (this shouldn't happen), resolve
                                    if (!nextToken) {
                                        resolve();
                                    }
                                    if (nextToken && nextToken !== currentTokens.accessToken) {
                                        // set new token expiration
                                        _this.consumer.setTokenExpiration(nextToken);
                                        resolve();
                                    }
                                });
                            });
                            return [2 /*return*/, ps];
                        }
                        return [2 /*return*/];
                    case 4:
                        _a = response.data, accessToken = _a.token, refreshToken = _a.refresh_token;
                        if (this.debug) {
                            console.log(new Date(), 'store new access token', accessToken);
                        }
                        return [4 /*yield*/, this.consumer.storeTokens({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                            })];
                    case 5:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TokenRefreshLink;
}(core_1.ApolloLink));
exports.TokenRefreshLink = TokenRefreshLink;
